export const environment = {
    production: true,
    // En production, l'API est sur le même domaine, mais avec le préfixe /api
    apiUrl: 'https://app.wariflow.com/api/v1/ma-franchise',
    externaleAuthUrl: "platform.wariflow.com/platform/wariflow",
    versionNumber: "0.0.1",
    baseApiSpeedpresta: "https://api.speedpresta.com/api/v1/",
    customerUrl: "CUSTOMERS/RETRIEVE_ALL_FROM_KEY",
    userPlatformUrl: "USER/RETRIEVE_ALL_FROM_KEY",
    customerRoleUrl: "ROLES/RETRIEVE_ALL_FROM_KEY",
    platformSiteUrl: "SITE/RETRIEVE_ALL_FROM_KEY",
    customerWariflowUrl: "RETRIEVE_FROM_KEY",
    similarityUrl: "https://api.mimicx.ai/api/v1/WARIFLOW/document/similarity",
    settingsWariflowUrl:"CONFIG/RETRIEVE_FROM_KEY",
    shipmentPlatformUrl:"SHIPMENT_PER_DESTINATION/RETRIEVE_ALL_FROM_KEY",
    productUrl: "PRODUCT/RETRIEVE_ALL_FROM_KEY",
    productCategoryUrl: "PRODUCT_CATEGORY/RETRIEVE_ALL_FROM_KEY",
    productCreateUrl: "PRODUCT/CREATE",
    invoiceApiUrl: "https://app.wariflow.com/api/v1/factu-flex/",
    speedprestaProxyUrl: "https://api.speedpresta.com/requests/get",
    supplierEncryptionKey: '',
    sentryDsn: '',
};
